{
  "Envanter": "Inventory",
  "envanter": {
    "Alış Firma": "Supplier Company",
    "Alış Tarih": "Purchase Date",
    "Alış Tarihi": "Purchase Date",
    "Değer": "Value",
    "Envanter": "Inventory",
    "Envanter Detay": "Inventory Detail",
    "Hareket": "Action",
    "Hareket Notu": "Action Note",
    "Marka": "Brand",
    "Model": "Model",
    "Nitelik": "Attribute",
    "Serial": "Serial",
    "Çoklu Giriş": "Multiple Entry",
    "ExcelAktar": "Export to Excel",
    "Status": "Status",
    "Kod": "Code",
    "Ad": "Name",
    "Tip": "Type",
    "Tür": "Kind",
    "Zimmet": "Custody",
    "Durum": "State",
    "Açıklama": "Description",
    "Aktif Kayıt": "Active Record",
    "Pasif Kayıt": "Passive Record",
    "Sıra": "Rank",
    "Aktif/Pasif": "Active/Passive",
    "Şube": "Branch",
    "Bilgi Notu": "Info Note"
  }
}
